export enum LeaveClassConfirmationStatus {
    Skipped,
    Confirmed,
}
